import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { AdminReducer } from './reducer';
import { AdminEffects } from './effects';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature('admin', AdminReducer),
    EffectsModule.forFeature([AdminEffects])
  ],
  providers: [AdminEffects]
})
export class AdminStoreModule {
}
